import makeService from './api';

export default makeService('forgot_passwords');
